var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F0C274",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0002 15.4375C19.8138 15.4375 17.271 17.9281 17.271 20.9522C17.271 22.7901 18.0227 24.3741 19.3656 25.3613C19.6617 25.5786 19.9156 25.9031 20.0118 26.3147C20.0916 26.6529 20.1823 27.0645 20.2722 27.5008H25.7282C25.818 27.0645 25.9087 26.6529 25.9885 26.3147C26.0857 25.9031 26.3387 25.5786 26.6347 25.3613C27.9767 24.3741 28.7293 22.7892 28.7293 20.9522C28.7293 17.9281 26.1865 15.4375 23.0002 15.4375ZM25.4651 28.8758H20.5343C20.6352 29.4597 20.7149 30.0125 20.7397 30.4103C20.7644 30.8292 21.077 31.2042 21.5381 31.3032L21.7177 31.3426C22.5611 31.525 23.4365 31.525 24.2807 31.3426L24.4604 31.3032C24.9215 31.2042 25.2341 30.8292 25.2597 30.4103C25.2836 30.0134 25.3624 29.4597 25.4642 28.8758H25.4651ZM15.896 20.9522C15.896 17.1242 19.0988 14.0625 23.0002 14.0625C26.9015 14.0625 30.1043 17.1251 30.1043 20.9522C30.1043 23.1742 29.184 25.1936 27.4487 26.4687C27.3905 26.5065 27.3473 26.5636 27.3268 26.63C27.196 27.1909 27.0756 27.7541 26.9657 28.3194C26.7979 29.1792 26.6613 30.0134 26.6329 30.4937C26.5687 31.5552 25.7877 32.4233 24.7519 32.6479L24.5722 32.6864C23.5364 32.9101 22.4639 32.9101 21.4281 32.6864L21.2484 32.6479C20.2126 32.4242 19.4316 31.5552 19.3674 30.4937C19.339 30.0134 19.2024 29.1792 19.0347 28.3194C18.9247 27.7541 18.8043 27.1909 18.6735 26.63C18.653 26.5636 18.6098 26.5065 18.5516 26.4687C16.8163 25.1936 15.896 23.1742 15.896 20.9531V20.9522Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.68b9f05fd6066e1e41a5608cc60fc188.svg";
export { ForwardRef as ReactComponent };